/** The seeded demo chat. Every request for it is answered in the browser and never sent. */
export const ORBIT_L4_DEMO_SESSION_ID = 'orbit-demo-layer-4';

/** Demo turn ids start here, far above any real id, so a turn path alone says it is a demo turn. */
export const ORBIT_L4_DEMO_TURN_ID_BASE = 900000000;

/** `?orbit_demo=1` opens the demo chat in the side panel. */
export const ORBIT_L4_DEMO_PARAM = 'orbit_demo';

export const ORBIT_L4_DEMO_TITLE = 'Demo: Layer 4 flows';

export const isOrbitL4DemoTurnId = (id: number): boolean => id >= ORBIT_L4_DEMO_TURN_ID_BASE;
